import React from 'react';
import { Box, Button, Typography } from '../ui';

interface CourseEnrollCtaProps {
  onSignIn: () => void;
}

const CourseEnrollCta: React.FC<CourseEnrollCtaProps> = ({ onSignIn }) => {
  return (
    <Box sx={{ width: '95%', maxWidth: '1500px' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          p: 2,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'primary.light',
          bgcolor: 'primary.light',
          color: 'primary.contrastText',
          flexWrap: 'wrap',
        }}
      >
        <Typography variant="body1" fontWeight={600}>
          Sign in to enroll in this course and unlock the full curriculum.
        </Typography>
        <Button variant="contained" color="primary" onClick={onSignIn} sx={{ minWidth: 140 }}>
          Sign In
        </Button>
      </Box>
    </Box>
  );
};

export default CourseEnrollCta;
